import { FontSize } from 'theme';
import React, { FC } from 'react';
import Text from 'Components/Typography/Text';
import { URL } from 'constants/urlMaps';
import { WLabel } from 'constants/enums';
import { colors } from 'constants/colors';
import { currentWLabel, selectByWL } from 'utils/wLabel';
import styled from 'styled-components';
import ColoredLinkWrapper from 'Components/Link/ColoredLinkWrapper';
import Link from 'Components/Link/LinkWrapper';
import ExternalLink from 'Components/ExternalLink';
import { checkAsEntity } from 'Modules/AAA/selectors';
import { useSelector } from 'react-redux';
import { useRequest } from 'swr.config';
import { getCartId } from 'Modules/Cart/selectors';
import { IOrderPublicOfferResponse } from 'Modules/Cart/types';
import { useServerData } from 'serverDataContext';
import fetchDataOnServer from './Condition.server';
import { MAIN_DOMAIN } from 'constants/constants';

export const SSR_KEY = 'CONDITION';
export const SERVICE_OFFER_TEST_ID = 'SERVICE_OFFER_TEST_ID';
export const AGENT_OFFER_TEST_ID = 'AGENT_OFFER_TEST_ID';

const ConditionWrapper = styled(Text)`
  color: ${colors.greyish};
  padding: 10px;
`;

const wlConditionLinkStyles = selectByWL({
  [WLabel.Default]: `color: ${colors.darkBlueGreen};`,
  [WLabel.Globus]: `color: ${colors.simpleOrange};`,
});

const ConditionLink = styled(ColoredLinkWrapper)`
  margin-left: 3px;
  ${wlConditionLinkStyles}
`;

const ServiceOfferLink: FC<{ serviceOfferUrl?: string }> = ({ serviceOfferUrl }) => (
  <ConditionLink underlineHover>
    <ExternalLink href={serviceOfferUrl} newTab data-testid={SERVICE_OFFER_TEST_ID}>
      сервиса
    </ExternalLink>
  </ConditionLink>
);

const AgentOfferLink: FC<{ agentOfferUrl?: string }> = ({ agentOfferUrl }) => {
  return agentOfferUrl ? (
    <>
      &nbsp;и
      <ConditionLink underlineHover>
        <ExternalLink href={`${MAIN_DOMAIN}${agentOfferUrl}`} newTab data-testid={AGENT_OFFER_TEST_ID}>
          агента
        </ExternalLink>
      </ConditionLink>
    </>
  ) : null;
};

const ReturnPolicyLink = () => (
  <ConditionLink underlineHover>
    <Link to={URL.wl_return_policy} target="__blank">
      возврата
    </Link>
  </ConditionLink>
);

const Condition = () => {
  const orderId = useSelector(getCartId);
  const isEntity = useSelector(checkAsEntity);
  const serverData = useServerData(SSR_KEY, [orderId]);
  const { data } = useRequest<IOrderPublicOfferResponse>(`orders/${orderId}/public_offer`, { initialData: serverData });

  return (
    <>
      {data && (
        <ConditionWrapper size={FontSize.xs}>
          Нажимая «Оформить» вы соглашаетесь с условиями
          {currentWLabel === WLabel.Default ? (
            <>
              &nbsp;оферты
              <ServiceOfferLink
                serviceOfferUrl={data?.service_offer_url || (isEntity ? URL.entity_offer : URL.offer)}
              />
              <AgentOfferLink agentOfferUrl={data?.offer_url} />.
            </>
          ) : (
            <>
              <ReturnPolicyLink />, &nbsp;оферты
              <ServiceOfferLink
                serviceOfferUrl={data?.service_offer_url || (isEntity ? URL.entity_offer : URL.offer)}
              />
              <AgentOfferLink agentOfferUrl={data?.offer_url} />.
            </>
          )}
        </ConditionWrapper>
      )}
    </>
  );
};

export default Condition;

Condition.fetchOnServer = fetchDataOnServer;
